import { FieldName, IBaseInputProps } from "../../../components/Forms/Inputs";
import { fieldId } from "../../../components/Forms/utils";

export const DurationField = (props: IBaseInputProps) => {
  const { name } = props;
  return (
    <div className="space-y-1 mb-2">
      <FieldName
        name="Duration (seconds)"
        hint="Leaving this blank will set the duration to 10 seconds"
      />
      <input
        id={fieldId(name)}
        className="w-96 border border-[#ccc] p-2.5 text-sm"
        type="number"
        onKeyDown={(event) => {
          if (!/[0-9]/.test(event.key) && event.key !== "Backspace") {
            event.preventDefault();
          }
        }}
        {...props}
      />
    </div>
  );
};
